import { GOST_7_32_2017 } from './gost-7.32-2017';
import { GOST_R_2_105_2019 } from './gost-r-2.105-2019';
import type { DeepPartial, Profile } from './types';

export type { DeepPartial, Profile } from './types';
export { GOST_2_105, GOST_7_32 } from './ids';

export const PROFILES: readonly Profile[] = [GOST_7_32_2017, GOST_R_2_105_2019];
export const DEFAULT_PROFILE: Profile = GOST_7_32_2017;

export function getProfile(id: string): Profile | undefined {
  return PROFILES.find((p) => p.id === id);
}

const isPlainObject = (v: unknown): v is Record<string, unknown> =>
  typeof v === 'object' && v !== null && !Array.isArray(v);

function merge(base: unknown, patch: unknown): unknown {
  if (!isPlainObject(base) || !isPlainObject(patch)) return patch === undefined ? base : patch;
  const out: Record<string, unknown> = { ...base };
  for (const [k, v] of Object.entries(patch)) {
    if (v === undefined) continue;
    out[k] = isPlainObject(v) && isPlainObject(base[k]) ? merge(base[k], v) : v;
  }
  return out;
}

/** Профиль с наложенными отступлениями методички. Массивы заменяются целиком. */
export function applyPatch(base: Profile, patch: DeepPartial<Profile>): Profile {
  return merge(base, patch) as Profile;
}

function diff(base: unknown, value: unknown): unknown {
  if (isPlainObject(base) && isPlainObject(value)) {
    const out: Record<string, unknown> = {};
    for (const k of new Set([...Object.keys(base), ...Object.keys(value)])) {
      const d = diff(base[k], value[k]);
      if (d !== undefined) out[k] = d;
    }
    return Object.keys(out).length ? out : undefined;
  }
  return JSON.stringify(base) === JSON.stringify(value) ? undefined : value;
}

/** Только отличия от базового профиля — компактно для передачи в ссылке. */
export function diffProfile(base: Profile, profile: Profile): DeepPartial<Profile> {
  return (diff(base, profile) as DeepPartial<Profile> | undefined) ?? {};
}
